var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMontana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.62,72.413l-5.802,27.442l4.547,8.415l-1.099,7.423c0,0,2.771,4.286,5.908,7.004c3.451,2.99,5.138,11.809,7.109,14.217 c1.628,1.989,7.527,7.004,7.527,7.004l-8.782,26.501l3.605,4.547l9.097-5.802l3.292,22.895l7.526,7.369l1.567,9.723 c0,0,4.235-1.724,5.646-1.724c1.412,0,19.445,1.565,20.542,1.41c1.098-0.157,1.098-3.607,1.098-3.607l0.164-0.041l4.071-1.056 l2.037,1.569l0.313,4.231l3.103,4.66l-0.016,0.097c0.037,0,0.074,0,0.109,0l-0.093-0.097l2.961-15.374 c21.139,4.811,100.193,13.296,127.67,16.164c5.951,0.62,9.486,0.98,9.486,0.98l2.313-26.555l0.877-10.057l6.428-73.782 C128.823,95.307,36.62,72.413,36.62,72.413z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMontana);
export default __webpack_public_path__ + "static/media/montana.c5ba14c2e4d93b8744c2c866ecb5d524.svg";
export { ForwardRef as ReactComponent };